import { makeRequest, makeUpload } from '../components/API/makeRequest';

let API_URL = window.API_URL; 
export let API_URL_BASE = window.API_URL_BASE; 

//======================================================================================================================
//
//                                             HELPER CALLS
//
//======================================================================================================================

function uuidv4() {
    let crypto = window.crypto || window.msCrypto;

    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        // eslint-disable-next-line no-mixed-operators
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

export const CreateAPITask = (flag, params, success, error) => {

    let guid = '{' + uuidv4() + '}';

    return (
        {
            flag      : flag,
            params    : params,
            successFn : success,
            errorFn   : error,
            GUID      : guid,
            running   : false,
            complete  : false
        }
    );
};

//======================================================================================================================
//
//                                             SERVER CALLS
//
//======================================================================================================================

let CLIENT_ID = window.CLIENT_ID; 

export const RESTService = {

    ping : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'RESTService.Ping', {}, {

        }, successFn, errorFn),

    getVersion : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'RESTService.GetVersion', {}, {

        }, successFn, errorFn),

    // /* keys: ID, name */
    // getInterventions : (params, successFn, errorFn) =>
    //     makeRequest(API_URL, CLIENT_ID, 'RESTService.GetInterventions', {}, {
    //
    //         disease           : params.disease,
    //         interventionClass : params.intervClassMstID,
    //
    //     }, successFn, errorFn),

    getRunServices : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'RESTService.RunServices', {}, {

            serviceList : params.serviceList,

        }, successFn, errorFn),

};






































export const LoginService = {

    getAccountInfo : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBLoginService.getAccountInfo', {}, {}, successFn, errorFn),

    getStatus : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBLoginService.Ping', {}, {}, successFn, errorFn),

    signedIn : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBLoginService.SignedIn', {}, {}, successFn, errorFn),

    login : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBLoginService.Login', {}, {
            appID: 'AIM',
            username: params.username,
            password: params.password
        }, successFn, errorFn),

    loginAsGuest : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBLoginService.Login', {}, {
            appID: 'AIM',
            username: 'guest',
            password: 123456
        }, successFn, errorFn),

    logout : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBLoginService.Logout', {}, {}, successFn, errorFn),

};
             
export const SpectrumService = {

    keepAlive : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.Alive', {}, {}, successFn, errorFn),

    getEverything : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.GetEverything', {}, {}, successFn, errorFn),

    getActiveProjectionList : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.GetActiveProjectionList', {}, {}, successFn, errorFn),

    getStoredProjectionList : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.GetStoredProjectionList', {}, {}, successFn, errorFn),

    //------------------------------------------------------------------------------------------------------------------

    // getAccountInfo : (successFn, errorFn) =>
    //     makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.GetAccountInfo', {}, {}, successFn, errorFn),

    getGBData : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.GetGB', {}, {}, (response) => {
            delete response.CountryRegionObjList;
            successFn(response);
        }, errorFn),

    getModvars : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.GetModvars', {}, {
            modvars : params.arr
        }, successFn, errorFn),

    setModvars : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.SetModvars', {}, {
            modvars : params.arr
        }, successFn, errorFn),

    getEditors : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.GetEditors', {}, {
            editors: params.arr
        }, successFn, errorFn),

    setEditors : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.SetEditors', {}, {
            editors : params.arr
        }, successFn, errorFn),

    getResultsData : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.GetResults', {}, {
            results : params.arr
        }, successFn, errorFn),

    //------------------------------------------------------------------------------------------------------------------

    upload : (file, mySuccess, myError) =>
        makeUpload(API_URL_BASE, CLIENT_ID, file, mySuccess, myError),

    createProjection : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.CreateProjection', {}, {
            countryISO : params.CountryISO,
            firstYear : params.FirstYear,
            finalYear : params.FinalYear,
            fileName : params.FileName,
            modList : params.ModList
        }, successFn, errorFn),

    openProjection : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.OpenProjection', {}, {
            fileTitle : params.FileTitle
        }, successFn, errorFn),

    saveProjection : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.SaveProjection', {}, {
            proj      : params.Proj,
            fileTitle : params.FileTitle
        }, successFn, errorFn),

    closeProjection : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.CloseProjection', {}, {
            proj : params.Proj
        }, successFn, errorFn),

    downloadProjection : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.DownloadProjection', {}, {
            fileTitle : params.FileTitle
        }, successFn, errorFn),

    deleteProjection : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.DeleteProjection', {}, {
            fileTitle : params.FileTitle
        }, successFn, errorFn),

    calculateProjection : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.CalculateProjection', {}, {
            proj : params.Proj
        }, successFn, errorFn),

    getResultTable : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.GetResultTable', {}, {
            proj     : params.proj,
            modID    : params.modID,
            resultID : params.resultID
            // chartOptions : ChartOptions
        }, successFn, errorFn),

    getAllResults : (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, 'GBSpectrumService.getAllResults', {}, {}, successFn, errorFn),

    getResultMenus: (params, successFn, errorFn) =>
        makeRequest(API_URL, CLIENT_ID, "GBSpectrumService.GetResultMenus", {}, {}, successFn, errorFn),

};
